package team.platforma.dictionary_data.network

import kotlinx.serialization.Serializable

@Serializable
data class AiResponseItem(
    val active: Boolean,
    val ai_model_group: AiModelGroup,
    val ai_model_id: Long,
    val config: Config,
    val created_at: String,
//    val deleted_at: Any,
    val description: String,
    val model: String,
    val name: String
)